// extracted by mini-css-extract-plugin
module.exports = {"pageFrame":"PageFrame_pageFrame__1OFdl","content":"PageFrame_content__1ceRO"};